import { useState, useEffect } from "react"
import DropDownSelect from "aldoo-ra/DropdownSelect"
import { api } from "aldoo-ra/API"
import useProductEditorTexts from "../useProductEditorTexts"

const crudAPI = api("crud")

export default function SubscriptionGroupEditor({ value, onChange, readOnly = false, refreshKey = 0 }) {
  const t = useProductEditorTexts()
  const [groups, setGroups] = useState([])
  const [loading, setLoading] = useState(true)

  // Re-fetch when refreshKey changes (e.g. after groups are added/removed in
  // the Manage Groups dialog) so the dropdown reflects the latest groups.
  useEffect(() => {
    crudAPI({
      get: {
        model: "ProductSubscriptionGroup",
        match: { deleted: { $ne: true } },
        sort: { name: 1 }
      }
    }).then((res) => {
      setGroups(Array.isArray(res) ? res : (res?.data ?? []))
    }).catch(() => {}).finally(() => setLoading(false))
  }, [refreshKey])

  const options = [
    { value: null, name: t`None` },
    ...groups.map((g) => ({ value: g._id, name: g.name }))
  ]

  const selected = options.find((o) => o.value && String(o.value) === String(value)) ?? options[0]

  const handleChange = (option) => {
    const opt = Array.isArray(option) ? option[0] : option
    onChange?.(opt?.value ?? null)
  }

  return (
    <DropDownSelect
      variant="admin_highlighted"
      disabled={readOnly || loading}
      options={options}
      nameField="name"
      valueField="value"
      placeholder={loading ? t`Loading groups…` : t`Select subscription group…`}
      value={selected}
      onChange={handleChange}
      showCheckbox={false}
      enableResetButton={false}
      allowEmptySelection={false}
    />
  )
}
